import React, { useState } from 'react'
import { Tooltip, IconButton, TableCell, TableRow } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Delete from './Delete'
import SummarizeIcon from '@mui/icons-material/Summarize'

const Row = ({ data, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)

  return (
    <>
      <TableRow style={{ borderBottom: 'unset' }}>
        <TableCell>{data.salesId}</TableCell>
        <TableCell> {data.payment}</TableCell>
        <TableCell>{data.commission}</TableCell>
        <TableCell>
          <a href={data.url} target='_blank' rel='noopener noreferrer'>
            <Tooltip title='View'>
              <IconButton>
                <SummarizeIcon />
              </IconButton>
            </Tooltip>
          </a>
        </TableCell>
        <TableCell>
          <Tooltip title='Delete'>
            <IconButton onClick={() => setOpenDelete(true)}>
              <DeleteOutlinedIcon size='small' />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
    </>
  )
}

export default Row
